import { Popover, Text, Tooltip } from '@mantine/core';
import type { MatchSuggestion } from '../../types';
import MatchComparison from './MatchComparison';

type FeedReferenceWithComparisonProps = {
  suggestion: MatchSuggestion;
};

export default function FeedReferenceWithComparison({
  suggestion,
}: FeedReferenceWithComparisonProps) {
  return (
    <Popover
      width={560}
      position="bottom-start"
      withArrow
      shadow="md"
      withinPortal
      middlewares={{ flip: true, shift: { crossAxis: true, padding: 16 } }}
    >
      <Tooltip label="Click to compare feed and asset details">
        <Popover.Target>
          <Text
            size="sm"
            td="underline"
            style={{ cursor: 'pointer', textDecorationStyle: 'dotted' }}
          >
            {suggestion.unprocessedProduct.providerReferenceNumber}
          </Text>
        </Popover.Target>
      </Tooltip>
      <Popover.Dropdown>
        <MatchComparison suggestion={suggestion} />
      </Popover.Dropdown>
    </Popover>
  );
}
